import { render, staticRenderFns } from "./ValidationField.vue?vue&type=template&id=0a10b1f0&"
import script from "./ValidationField.vue?vue&type=script&lang=js&"
export * from "./ValidationField.vue?vue&type=script&lang=js&"
import style0 from "./ValidationField.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ValidationField.vue"
export default component.exports